<script>
    export let href = "";
</script>

<a target="_blank" rel="noreferrer" {href}><slot /></a>
